import { Close } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import { ReactNode } from 'react';
import { styledDialog } from './Dialog.style';

type TProps = {
  open: boolean;
  handleClose: () => void;
  children: ReactNode;
  action: ReactNode;
  title: string;
  /** 指定彈窗寬度（如提示類小彈窗）；未指定時維持 MUI 隨內容自適應 */
  width?: string | number;
};

export const BaseDialog = ({
  open,
  handleClose,
  children,
  action,
  title,
  width,
}: TProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={width ? { sx: { width, maxWidth: '90vw' } } : undefined}
    >
      <styledDialog.title>
        {title}
        <Close
          onClick={handleClose}
          sx={{ cursor: 'pointer', color: 'grey.600' }}
        />
      </styledDialog.title>
      <styledDialog.content>{children}</styledDialog.content>
      <styledDialog.actions>{action}</styledDialog.actions>
    </Dialog>
  );
};
